var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcProfileAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0026 2.3335C10.9459 2.3335 8.46094 4.8185 8.46094 7.87516C8.46094 10.8735 10.8059 13.3002 13.8626 13.4052C13.9559 13.3935 14.0493 13.3935 14.1193 13.4052C14.1426 13.4052 14.1543 13.4052 14.1776 13.4052C14.1893 13.4052 14.1893 13.4052 14.2009 13.4052C17.1876 13.3002 19.5326 10.8735 19.5443 7.87516C19.5443 4.8185 17.0593 2.3335 14.0026 2.3335Z",
    fill: "#07506D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9291 16.5084C16.6741 14.3384 11.3657 14.3384 8.0874 16.5084C6.60573 17.5 5.78906 18.8417 5.78906 20.2767C5.78906 21.7117 6.60573 23.0417 8.07573 24.0217C9.70906 25.1184 11.8557 25.6667 14.0024 25.6667C16.1491 25.6667 18.2957 25.1184 19.9291 24.0217C21.3991 23.03 22.2157 21.7 22.2157 20.2534C22.2041 18.8184 21.3991 17.4884 19.9291 16.5084ZM16.3357 21.1517H14.8774V22.61C14.8774 23.0884 14.4807 23.485 14.0024 23.485C13.5241 23.485 13.1274 23.0884 13.1274 22.61V21.1517H11.6691C11.1907 21.1517 10.7941 20.755 10.7941 20.2767C10.7941 19.7984 11.1907 19.4017 11.6691 19.4017H13.1274V17.9434C13.1274 17.465 13.5241 17.0684 14.0024 17.0684C14.4807 17.0684 14.8774 17.465 14.8774 17.9434V19.4017H16.3357C16.8141 19.4017 17.2107 19.7984 17.2107 20.2767C17.2107 20.755 16.8141 21.1517 16.3357 21.1517Z",
    fill: "#116584"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfileAdd);
export default __webpack_public_path__ + "static/media/ic-profile-add.5d8768c40b4cf609f2f8ab6ebd64cf9f.svg";
export { ForwardRef as ReactComponent };